import React from 'react';
import { Check } from 'lucide-react';
import { Reveal } from '../Reveal';
import { SectionBand, Eyebrow } from './SectionBand';
const youBring = ['The book', 'Existing offers', 'Point of view', 'Judgment', 'Brand materials', 'A few focused working sessions'];
const weBuild = ['Reader strategy', 'Diagnostic & readout', 'Concept Guide', 'Interactive application', 'Reader signals', 'Offer routing', 'Sales enablement', 'Content & business assets', 'Copy', 'Design', 'Implementation', 'Launch support'];
export function DoneForYou() {
  return <SectionBand tone="paperDark" width="wide" data-id="element-654" data-mp="2f2kav0f75rjq">
      <div className="max-w-3xl" data-id="element-655" data-mp="20cv7cyjmtbga">
        <Reveal data-id="element-656" data-mp="20do374h1ygjn">
          <Eyebrow data-id="element-657" data-mp="20e68srplu748">Done for you</Eyebrow>
          <h2 className="mt-4 font-serif text-3xl leading-tight text-navy md:text-5xl" data-id="element-658" data-mp="25b6f93qd9bvv">
            You wrote the book.
            <br data-id="element-659" data-mp="1rbeyiv8gthe6" />
            <span className="italic text-seaglass" data-id="element-660" data-mp="1rcyfyp5uxyhj">
              We build the leverage around it.
            </span>
          </h2>
        </Reveal>
      </div>

      <div className="mt-14 grid items-start gap-6 lg:grid-cols-[0.72fr_1.28fr] lg:gap-8" data-id="element-661" data-mp="1xu1kct4ieg9t">
        {/* You bring — lighter */}
        <Reveal delay={0.1} data-id="element-662" data-mp="1su6t2ogtnoo8">
          <div className="rounded-3xl border border-gray-200 bg-paper p-7 md:p-8" data-id="element-663" data-mp="1suyj7jrngu74">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-text-muted" data-id="element-664" data-mp="27rz5h7r2nwy7">
              You bring
            </p>
            <ul className="mt-5 space-y-3" data-id="element-665" data-mp="22rjp07bhu9c0">
              {youBring.map(item => <li key={item} className="flex items-start gap-3 text-text" data-id="element-666" data-mp="1f4bkvspsx6bk">
                  <span className="mt-2 h-1.5 w-1.5 flex-shrink-0 rounded-full bg-text-muted/50" data-id="element-667" data-mp="1a5rzbtf4dwjq" />
                  <span className="leading-relaxed" data-id="element-668" data-mp="1ouofkdrbyfvf">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>

        {/* We build — heavier, elevated */}
        <Reveal delay={0.15} data-id="element-669" data-mp="wcsjtrfc82c6">
          <div className="rounded-3xl border-2 border-seaglass bg-navy p-7 text-paper shadow-[0_30px_60px_-28px_rgba(26,40,56,0.6)] md:p-9" data-id="element-670" data-mp="wc0zjcr6xr17">
            <p className="text-xs font-semibold uppercase tracking-[0.18em] text-seaglass-light" data-id="element-671" data-mp="1h2czwrq1t32k">
              We build
            </p>
            <ul className="mt-5 grid gap-x-6 gap-y-3 sm:grid-cols-2" data-id="element-672" data-mp="1l36qxtysexzo">
              {weBuild.map(item => <li key={item} className="flex items-start gap-3" data-id="element-673" data-mp="1puex8h4tm38m">
                  <span className="mt-0.5 flex h-5 w-5 flex-shrink-0 items-center justify-center rounded-full bg-seaglass text-white" data-id="element-674" data-mp="1utrvrz520yr1">
                    <Check className="h-3 w-3" strokeWidth={3} data-id="element-675" data-mp="y4aj307nmcfu" />
                  </span>
                  <span className="leading-relaxed text-paper/90" data-id="element-676" data-mp="124kmc542aor0">{item}</span>
                </li>)}
            </ul>
          </div>
        </Reveal>
      </div>

      <Reveal delay={0.2} data-id="element-677" data-mp="176a03sio5gis">
        <p className="mx-auto mt-12 max-w-2xl text-center text-lg text-text-muted" data-id="element-678" data-mp="1c30g6fuh4c47">
          You stay the author and the expert. You do not become a project
          manager or a tech manager.
        </p>
      </Reveal>
    </SectionBand>;
}